var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RefundHeader',{attrs:{"img_header":_vm.header_image,"header":"เมนูรับคืนสินค้า","link_back":"sell/all"}}),_c('MenuRefund'),_c('Refund_wait_for_process')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }